module.exports = __webpack_public_path__ + "img/eth.878d30dd.svg";